export const header = {
  headerInfo: {
    customerNumber: 'Kundennummer: {{b2bUnitId}}'
  }
};
